<script>
export default {
	name: 'MAGBrandsCarousel',
	inheritAttrs: false,
};
</script>

<script setup>
import VueSwiper from '~/components/VueSwiper.vue';
import { isMobileViewport } from '~/logic/composables/breakpoints.js';
import { useGlobalAEMState } from '~/logic/aem/global-aem-state.js';

const props = defineProps({
	// modelValue: { type: String, default: '' },
	isHideInMobile: { type: Boolean, default: false },
	isHideInDesktop: { type: Boolean, default: false },
	isEnableLoop: { type: Boolean, default: false },
	brandsCarouselMultilist: { type: Array, default: () => [] },
});


const { isEditorMode } = useGlobalAEMState();
const siteName = window.siteName;

const computedSlidePerView = computed(() => {
	if (isMobileViewport.value) {
		return 1.5;
	}
	return props.brandsCarouselMultilist.length <= 5 ? 5 : 5.5;
});

const computedIsSlideCenter = computed(() => {
	if (isMobileViewport.value && props.brandsCarouselMultilist.length === 1) return true;
	if (!isMobileViewport.value && props.brandsCarouselMultilist.length <= 4) return true;
	return false;
});

const computedEnableGrab = computed(() => {
	if (isMobileViewport.value && props.brandsCarouselMultilist.length === 1) return false;
	if (!isMobileViewport.value && props.brandsCarouselMultilist.length <= 5) return false;
	return true;
});

const isAutoplay = {
	delay: 1500,
	disableOnInteraction: false,
};

</script>

<template>
<section v-if="isEditorMode && props.isHideInDesktop">
	<div class="generic-container py-10 text-center">
		<p>Hidden in: <span v-if="props.isHideInDesktop">Desktop</span> <span v-if="props.isHideInMobile">, Mobile</span></p>
	</div>
</section>

<section v-else class="MAGBrandsCarousel" :class="[{ 'is-editor-mode': isEditorMode }]">
	<div
		v-if="(isMobileViewport && !props.isHideInMobile) || (!isMobileViewport && !props.isHideInDesktop)"
		class="bg-secondary-teal-ultralight"
		:data-use-theme="siteName"
	>
		<VueSwiper
			v-if="props.brandsCarouselMultilist.length"
			:dormantMode="isEditorMode"
			:slidesPerView="computedSlidePerView"
			:loop="props.brandsCarouselMultilist.length >= 5 && props.isEnableLoop"
			:autoplay="props.isEnableLoop && isAutoplay"
			:spaceBetween="props.brandsCarouselMultilist.length > 1 ? 48 : 0"
			class="banner-carousel-swiper"
			:class="{
				'use-centralize': computedIsSlideCenter,
				'is-grabbing': computedEnableGrab,
			}"
		>
			<div
				v-for="item in props.brandsCarouselMultilist"
				:key="`brand-carousel-${item.brandImageId}`"
				class="brand-carousel-item py-4"
			>
				<img
					class="brand-carousel-img object-cover w-full"
					:src="item.brandImage"
					:alt="item.brandImageAltText"
				/>
			</div>
		</VueSwiper>
	</div>
</section>

</template>


<style lang="scss">
.is-editor-mode {
	--slideGap: 48px;
	.banner-carousel-swiper {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: var(--slideGap);
	}

	.swiper-wrapper {
		transition-timing-function: linear;
	}
	
	.swiper-slide {
		width: calc((100% / 6) - var(--slideGap));
	}
}

.MAGBrandsCarousel .use-centralize .swiper-wrapper {
	display: flex;
	justify-content: center;
}
</style>

<style scoped lang="scss">
@use 'sass:color';
@use '~/styles/partials/_var.scss';

.MAGBrandsCarousel {
	.is-grabbing {
		cursor: grab;

		&:active {
			cursor: grabbing;
		}
	}

	
}

</style>


